module.exports = lib_react_ioc;